<template>
  <SAuthForm
    :isAuthPage="isAuthPage"
    :isDisplayedImageAndTitle="isDisplayedImageAndTitle"
    :lang="this.$route.params.lang"
    :location="getLocation"
    termsAndConditionsPageName="terms-and-conditions"
    privacyPolicyPageName="https://www.slg.lu/en/politique-de-confidentialite/"
    @setGlobalLoading="setGlobalLoading"
    @setAuthToken="setAuthToken"
    @populateUserProfileInfo="populateUserProfileInfo"
    @redirect="redirect"
  />
</template>

<script lang="ts">
export default {
  name: 'AuthForm',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { SAuthForm } from '@slg/web-customer-shared';
import { useStore, useGlobalErrorDialog } from '@/composables';

defineProps({
  isAuthPage: {
    type: Boolean,
    default: true,
  },
  isDisplayedImageAndTitle: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['onSignInSuccess']);
const store = useStore();
const { setGlobalError } = useGlobalErrorDialog();

const getLocation = computed(() => store.getters['auth/getLocation']);

function setGlobalLoading(isLoading: boolean) {
  store.commit('common/setGlobalLoading', isLoading);
}

function setAuthToken(authToken: string) {
  if (localStorage.getItem('authToken') !== authToken) {
    store.commit('auth/clearAuthTokenAndProfileInfo');
    store.commit('auth/setAuthToken', authToken);
  }
}

async function populateUserProfileInfo() {
  try {
    await store.dispatch('auth/populateUserProfileInfo');
  } catch (e) {
    await setGlobalError(e as any);
  }
}

async function redirect() {
  await emit('onSignInSuccess');
}
</script>
